import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';
import {getTs} from '../../../library/dates';
import {getEntranceStatus} from './entranceStatus.utils';

// מחזיר את מצב כרטיס הכניסה; כשהמצב הוא "ספירה לאחור" הוא מתקתק כל שנייה כדי לעדכן את הזמן שנותר.
export function useEntranceStatus() {
    const data = useSelector((s: RootState) => s.eTicket.data);
    const [now, setNow] = useState(getTs());
    const status = getEntranceStatus(data, now);

    useEffect(() => {
        if(status.state !== 'countdown')
            return;
        const id = setInterval(() => setNow(getTs()), 1000);
        return () => clearInterval(id);
    }, []);
    const remainingSec = status.startSec != null ? Math.max(0, status.startSec - now) : 0;
    return {...status, remainingSec};
}
